module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// BlogViewer Widget

(function (fox, $) {
	'use strict';

	fox.registerWidget('BlogViewer', {
		
		configure: function () {
			this.registerOptions('', {
				'embed.container': '#blog-container',
				menuSelector: false,
				autoRender: true,
				externalLoad: true,
				loadOnRun: true,
				getImageFromHTML: false,
				widgets: {
					dl: {
						widget: 'Datalayer',
						cacheChannel: 'content',
						method: 'blog.get',
						limit: 5,
						metaFields: ['shortContent', 'totalCount'],
						fields: ['tags.title'],
						jsonize: false,
					}
				},
				'list.hooks.onStartRendering': '@parent:sortShortData',
				'list.hooks.onAddedToDom': function () {
					var
						grid = this.getParent();

					if (grid.dl.getCount() === 0) {
						if (grid._indom) {
							$(grid.element[0]).hide();
						}
					}
				}
			});
			fox.registerTemplateModifier('isWide', function (obj) {
				if (fox.isEmpty(obj)) return;
				var w = parseInt(obj.width);
				var h = parseInt(obj.height);

				return (w / h > .84); 
			});
			this.callParent('configure', arguments);
		},

		running: function () {
			if (this.getOption('loadOnRun') === true) {
				this.loadPosts();
			}
		
			this.callParent('running', arguments);
		},

		loadPosts: function () {
			if (!fox.site.member) {
				this.dl.setTransitParameter('notMember', 1);
			}

			this.dl.load();
		},

		sortShortData: function () {
			var temp, sortedShortContent, menu, IMG_TYPE = 3;

			temp = [];

			this.visual = (this.dl.getCount() > 0);

			fox.each(this.dl.getCollection(), function (val, key) {
				var type3Exists = false;
				
				if (val._shortContent) {
					sortedShortContent = 
						fox.toArray(val._shortContent.collection).sort(function (f, s) {
							if (f.type === IMG_TYPE) {
								type3Exists = true;
							}
							return f.type > s.type ? -1 : 1;
						});

					if (sortedShortContent.length) {
						val._shortContent.collection = type3Exists ? sortedShortContent : this.getImageFromShortContent(sortedShortContent);
					}
				}

				temp.push(val);
			}, this);

			this.dl.setCollection(temp);
		},

		getImageFromShortContent: function (sortedShortContent) {
			var regExp = /<img[\s\w=\-;:\"\'\.]*src=\"([\S]+)\"[\s\w=\-;:\"\'\.]*\/>/;
			var content = sortedShortContent[0].content;
			var IMG_TYPE = 3;
			var matches;

			while ((matches = content.match(regExp)) !== null) {
				content = content.replace(matches[0], '');

				sortedShortContent.push({
					type: IMG_TYPE,
					content: matches[1]
				});
			}

			sortedShortContent[0].content = content;

			return sortedShortContent.reverse();
		}

	}, 'Grid');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/blog/blogViewer.js
// module id = 833
// module chunks = 4